import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./case.scss";

gsap.registerPlugin(ScrollTrigger);

// Drives every [data-parallax] media block on the page from one place.
// Motivated by depth: the media drifts slower than the page, so a full-bleed
// product shot reads as sitting behind the text rather than taped to it.
export function useStageParallax() {
  useEffect(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      const ctx = gsap.context(() => {
        gsap.utils.toArray("[data-parallax]").forEach((el) => {
          gsap.fromTo(
            el.querySelector("img") || el,
            { yPercent: -8 },
            {
              yPercent: 8,
              ease: "none",
              scrollTrigger: {
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.5,
              },
            }
          );
        });
      });
      return () => ctx.revert();
    });
    // Images below the fold change the document height as they arrive, which
    // invalidates every trigger measured before them.
    const refresh = () => ScrollTrigger.refresh();
    const imgs = [...document.images].filter((i) => !i.complete);
    imgs.forEach((i) => i.addEventListener("load", refresh, { once: true }));
    window.addEventListener("load", refresh, { once: true });

    return () => {
      imgs.forEach((i) => i.removeEventListener("load", refresh));
      window.removeEventListener("load", refresh);
      mm.revert();
    };
  }, []);
}

// A horizontally scrollable strip. This used to pin the viewport and scrub the
// track with ScrollTrigger, but pinning fought the surrounding layout (the
// pinned section overlapped the heading above it) and made vertical scrolling
// feel broken. Native overflow with snap points behaves predictably, works
// with a trackpad, a thumb and a keyboard, and needs no JavaScript.
export const PanGallery = ({ children, label }) => (
  <section className="cs-pan" aria-label={label}>
    <div className="cs-pan__track" tabIndex={0}>
      {children}
    </div>
  </section>
);
